import styled from "styled-components";
import Select from "react-select";

const Label = styled.label`
  color: #333333;
  display: block;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 0.875rem;
  font-weight: bold;
  margin-bottom: 8px;
`;

/**
 * Note: value is stored as { label: "Assign client(s) to check-in form", value: "0" } by default
 * 
  <CustomSelect
    options={[
      { label: "Assign client(s) to check-in form", value: "0" },
      { label: "Delete client(s) from check-in form", value: "1" },
    ]}
    value={scheduleType}
    onChange={(val) => setScheduleType(val)}
    label="Schedule Type"
  />
 */

const AVNStyles = {
  borderRadius: "50px",
  background: "#eaedf5",
  border: "1px solid #DDDEE8",
  borderColor: "#DDDEE8",
  color: "#5a5a5a",
  cursor: "pointer",
  fontFamily: "DM Sans, sans-serif",
  fontSize: "1rem",
  fontWeight: 300,
  padding: "4px 8px",
  height: "47px",
  "&:hover": {
    borderColor: "#0ab23b",
  },
};

const FBBCStyles = {
  borderRadius: "0px",
  background: "#ffffff",
  border: "1px solid #DDDEE8",
  borderColor: "#DDDEE8",
  color: "#fff",
  cursor: "pointer",
  fontFamily: "Roboto, sans-serif",
  padding: "3px 8px",
  height: "45px",
  "&:hover": {
    borderColor: "#FFC000",
  },
};

const CustomSelect = ({ label, options, value, onChange }) => {
  const theme = process.env.REACT_APP_THEME;
  const styles = theme === "AVATAR" ? AVNStyles : FBBCStyles;
  return (
    <div style={{ display: "block" }}>
      <Label>{label}</Label>
      <div style={{ minWidth: "120px" }}>
        <Select
          options={options}
          value={value}
          onChange={onChange}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              ...styles,
              boxShadow: state.isFocused
                ? theme === "AVATAR"
                  ? "0px 0px 0px 3px #0ab23b45"
                  : "0px 0px 0px 3px #FFC00045"
                : "none",
              border: state.isFocused
                ? theme === "AVATAR"
                  ? "1px solid #0ab23b !important"
                  : "1px solid #FFC000 !important"
                : "1px solid #DDDEE8 !important",
            }),
            menu: (baseStyles, state) => ({
              ...baseStyles,
              zIndex: 35,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default CustomSelect;
